<template>
  <button class="button is-success" :class="{ 'is-loading': loading }" @click="$emit('click')">{{ label }}</button>
</template>

<script>
export default {
  name: 'PrimaryButton',
  props: {
    label: String,
    loading: Boolean
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/forms/PrimaryButton.vue